<template>
    <!--弹窗-->
    <el-dialog
        width="1200px"
        title="选择Teambition任务"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item label="名称：" class="query-form-item">
                <el-input style="width: 210px;" placeholder="请输入名称" v-model="query.keyword"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="search" @click="getCategoryList">搜索</el-button>
            </el-form-item>
        </el-form>

        <el-table
            :row-key="getRowKeys"
            v-loading="loading"
            :data="filterList"
            class="table_content"
            size="mini"
            border
            height="400"
            :row-class-name="tableRowClassName"
            style="width: 100%;">
            <el-table-column label="选中情况" width="100" align="center">
                <template slot-scope="scope">
                    <el-checkbox :value="scope.row.selected == 1"
                                 @change="changeCheckBox(scope.row, scope.$index)" :disabled="usedList.includes(scope.row.id)"></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column
                label="任务id"
                :resizable="false"
                width="190"
                prop="id"
                align="center">
            </el-table-column>
            <el-table-column
                label="项目名"
                width="250"
                :resizable="false"
                prop="project_name"
                align="center">
            </el-table-column>

            <el-table-column
                min-width="140"
                label="名称"
                :resizable="true"
                prop="content"
                align="center">
            </el-table-column>
        </el-table>

        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="primary"
                @click="handleClose()">关 闭
            </el-button>
            <el-button
                style="float:right;margin-left:6px;width: 80px"
                size="mini"
                type="success"
                @click="handleClose(true)">分 配
            </el-button>

            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                @click="cancelBind(undefined)">取消当前绑定
            </el-button>

        </el-row>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'

export default {
    data() {
        return {
            visible: false,
            list: [],
            loading: false,
            query: {
                keyword: '',
            },
            usedList: [],
        }
    },
    computed: {
        filterList() {
            return this.list.filter(item => {
                console.log('item:', item)
                if (item.content.indexOf(this.query.keyword) > -1 || this.query.keyword === '') {
                    return true
                }
                return false
            })
        }
    },
    methods: {
        showModal(data) {
            this.tempData = JSON.parse(JSON.stringify(data))
            this.getCategoryList()
            this.visible = true
        },
        changeCheckBox(data, index) {
            for (const listIndex in this.filterList) {
                if (listIndex == index) {
                    this.$set(this.filterList[listIndex], 'selected', 1)
                } else {
                    this.$set(this.filterList[listIndex], 'selected', 0)
                }
            }
            // this.$set(this.list[index], 'selected', this.list[index].selected == 0 ? 1 : 0)
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getCategoryList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getCategoryList()
        },
        closeCllback(isshow) {
            this.showAddRootCategoryl = false
            isshow == true && this.getCategoryList()
        },
        getRowKeys(row) {
            return row.id
        },
        tableRowClassName({row, rowIndex}) {
            if (this.usedList.indexOf(row.id) > -1) {
                return 'used-row'
            }
            if (row.selected == 1) {
                return 'selected-row'
            }
            return ''
        },
        addFunc() {
            this.showAddRootCategoryl = true
        },
        getCategoryList() {
            this.loading = true
            api.asin_list_get_teambition_task_list({
                list_id: this.tempData.id,
            }).then(res => {
                if (res.code === 0) {
                    let resList = (res.data.list || []).map(item => {
                        item.selected = false
                        if (item.id === this.tempData.teambition_task_id) {
                            item.selected = true
                        }
                        return item
                    })

                    // 先处理selected为true的项目移动到开头
                    for (let i = resList.length - 1; i >= 0; i--) {
                        if (resList[i].selected) {
                            resList.unshift(resList.splice(i, 1)[0])
                        }
                    }
                    
                    // 再处理usingIds中的项目移动到末尾
                    if ((res.data.using_ids || []).length > 0) {
                        let usingIds = res.data.using_ids
                        for (let i = resList.length - 1; i >= 0; i--) {
                            if (usingIds.indexOf(resList[i].id) > -1) {
                                resList.push(resList.splice(i, 1)[0])
                            }
                        }
                    }
                    this.usedList = (res.data || {}).using_ids || []
                    this.list = resList
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 关闭弹窗
        handleClose(getIds = false) {
            let tempObj = {id: '', full_name: ''}
            if (getIds === true) {
                for (const item of this.list) {
                    if (item.selected == 1) {
                        tempObj = item
                    }
                }
                if (tempObj.id) {
                    this.cancelBind(tempObj.id)
                }
            } else {
                this.visible = false
                this.$emit('close-callback', true)
            }
            this.query.keyword = ''
        },
        cancelBind(id) {
            this.loading = true
            api.asin_list_bind_asin_teambition_task({
                list_id: this.tempData.id,
                task_id: id
            }).then(res => {
                if (res.code === 0) {
                    this.$message.success('分配成功')
                    this.visible = false
                    this.$emit('close-callback', false)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}

/deep/ .used-row {
    background-color: #f5f5f5 !important;
    color: #999 !important;
}

/deep/ .used-row td {
    background-color: #f5f5f5 !important;
}

/deep/ .selected-row {
    background-color: #f0f9ff !important;
    color: #2d5a8b !important;
}

/deep/ .selected-row td {
    background-color: #f0f9ff !important;
}
</style>
